import { Message } from 'semantic-ui-react';

const EndOfLife = (props) => {
    return (
            <Message size="tiny" visible warning style={{ marginTop: '5px', marginBottom: '20px' }}>
                <Message.Content>
                    <Message.Header >
                        <h2>Sovellus poistuu käytöstä kesäkuussa 2027</h2>
                    </Message.Header>
                    <p>
                        Sovellus on tullut teknisen elinkaarensa päähän, eikä sen vanhentunut teknologia enää mahdollista tarkoituksenmukaista ylläpitoa ja kehittämistä. Tämän vuoksi lakkautamme sovelluksen kesäkuussa 2027. Sen jälkeen sovellukseen ei voi enää kirjautua eikä sitä voi käyttää. Kehitämme tilalle ajanmukaisia, entistä paremmin käyttäjien tarpeisiin vastaavia ratkaisuja työpaikkojen työturvallisuuden kehittämiseen.
                    </p>
                    <p>
                        Työturvallisuuskeskus ei säilytä sovellukseen tallennettuja tietoja lakkauttamisen jälkeen, eikä tietoja siirretä uusiin järjestelmiin. Sovelluksen käyttäjän vastuulla on ottaa tarvitsemansa tiedot talteen hyvissä ajoin ennen sovelluksen sulkemista, kuitenkin viimeistään toukokuun 2027 loppuun mennessä.
                    </p>
                    <p>
                        Lisätietoja: <a class="green" href="https://www.ttk.fi/sovellus" target="_blank" rel="noopener noreferrer">https://www.ttk.fi/sovellus</a>
                    </p>
                </Message.Content>
            </Message>
    );
}

export default EndOfLife;